import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "@app/store";
import { useLazyGetFaqsQuery } from "@modules/faq";
import { setFaqs } from "@modules/faq/store/faq.slice";
import { arrayMoveImmutable } from "array-move";
import { IFaq } from "@modules/faq/types";
import { useUpdateFaqOrderingMutation } from "@modules/faq/api/faq.api";

export const useFaqOrderingLogic = () => {
  const dispatch = useAppDispatch();
  const faqList = useAppSelector((state) => state.faq.faqs)
  const [updateOrdering] = useUpdateFaqOrderingMutation()
  const [getFaqs] = useLazyGetFaqsQuery()

  const handleGetRequest = async () => {
    try {
      const responseFaqs = await getFaqs({}).unwrap();

      dispatch(setFaqs(responseFaqs.faqs));
    } catch (error) {
      console.log(error);
    }
  };

  const onSortEnd = async (oldIndex: number, newIndex: number) => {
    const clone = JSON.parse(JSON.stringify(faqList)) as IFaq[]

    const sortedList = arrayMoveImmutable(clone, oldIndex, newIndex)

    dispatch(setFaqs(sortedList));
    await updateOrdering({ ids: sortedList.map((item) => item.id) })
  }

  useEffect(() => {
    handleGetRequest()
  }, [])

  return {
    faqList,
    onSortEnd,
  }
}
